export default "__VITE_ASSET__Cys3UcQX__"